import { defineMessages } from 'react-intl';

export default defineMessages({
  currency: {
    id: 'currency',
    description: 'USD',
    defaultMessage: 'USD',
  },
  duplicate: {
    id: 'duplicate',
    description: 'duplicate',
    defaultMessage: 'Duplicate',
  },
});
